/**
 *
 * @license
 * Copyright Santander UK. All Rights Reserved.
 * Module is to handle adobe tagging for SBBI and Retail Markets
 */
import { Injectable } from '@angular/core';
import { constants } from '../../configs/config-internal-constants';
import { StartupService } from 'src/app/common/services/startup.service';
import { Subscription, timer } from 'rxjs';
import { NumbersEnum } from 'src/app/shared/models/number.model';
import { CommonUtilities } from '../../shared/util/common-utilities';

@Injectable()
export class AdobeAnalyticsService {
  private readonly vaChatbot = "va-chatbot";
  private readonly chatbotDOMElement: HTMLElement;

  constructor(private readonly startup: StartupService) {
    this.chatbotDOMElement = document.createElement(this.vaChatbot);
  }

  // Used for every page load
  pageLoaded() {
    try {
      this.trackCall(constants.ADOBE_PAGE_VIEW);
      // Eagerly load chatbot element with engagement chatwithus
      this.updateChatbotReferrerId(this.startup.chatWithUs);
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }

  // Used for any action taken on a page
  actionEvent(linkName: string) {
    try {
      this.digitalData.page.pageInfo.linkName = linkName;
      this.trackCall(constants.ADOBE_TRACK_LINK);
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }

  // Used to report validation errors
  validationEvent(errorListJSON: {}) {
    try {
      this.digitalData.page.pageInfo.errorMsg = errorListJSON;
      this.trackCall(constants.ADOBE_TRACK_ERROR_VALIDATION);
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }

  // used to report system errors
  errorEvent(errorCode: string, errDescription: string) {
    try {
      this.digitalData.page.errorCode = errorCode;
      this.digitalData.page.errorDescription = errDescription;
      this.trackCall(constants.ADOBE_TRACK_ERROR);
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }

  private getVaChatbotElement(): Element {
    return document.querySelector(this.vaChatbot);
  }

  // Function to up the Chatbot 
  triggerEngagement(engagementId: string): Subscription { 

    this.updateChatbotReferrerId(engagementId);
    return timer(NumbersEnum.fiveHundred).subscribe(() => {
      const chatbotElement = this.getVaChatbotElement();
      if (CommonUtilities.isNotNullEmptyAndUndefined(window) 
        && CommonUtilities.isNotNullEmptyAndUndefined(window['clickButtonOpen'])
        && CommonUtilities.isNotNullEmptyAndUndefined(window['newChatPage'])
        && chatbotElement) {
        window?.['newChatPage']?.();
        window?.['clickButtonOpen']?.();
      }
    });
  }

  // update va-chatbot referrerId
  updateChatbotReferrerId(engagementId: string) {
    this.chatbotDOMElement.setAttribute('context', `{"referrerId": "${engagementId}"}`);
    this.chatbotDOMElement.setAttribute('autoconfig', this.startup.autoconfigURL);
    document.body.appendChild(this.chatbotDOMElement);
  }
  // Used to make changes to digitalData object
  get digitalData(): any {
    try {
      return (window as any).digitalData;
    } catch (ex) {
      return {};
    }
  }
  set digitalData(data: any) {
    try {
      (window as any).digitalData = data;
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }

  // Makes the call to Adobe
  private trackCall(trackType: string) {
    try {
      if ((window as any)._satellite) {
        (window as any)._satellite.track(trackType);
      }
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }

  // method to handle setting adobe data
  // ex: on page load
  setPage(pageIdentifier: string) {
    try {
      this.digitalData.page.pageInfo.pageIdentifier = pageIdentifier;
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }

  setSegment(segment: string) {
    try {
      this.digitalData.page.pageInfo.segment = segment;
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }

  setSubsection(subsection: string) {
    try {
      this.digitalData.page.pageInfo.subsection1 = subsection;
    } catch (ex) {
      // TODO: In case required, Log error
    }
  }
}


